import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useContext,
} from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { deferralListColumns } from "../../../utils/constant";
import { axios_instance } from "../../../api/axios_instance";
import { DetailPageLoadingModalContext } from "../../../ContextAPI/context";
import { format, parseISO, parse } from "date-fns";

const DeferralListModal = ({ closeDeferralListModal, lead_id }) => {
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeDeferralListModal);
  }, [closeDeferralListModal]);

  const [defferalList, setDefferalList] = useState([]);
  const { setShowLoadingModal } = useContext(DetailPageLoadingModalContext);

  const fetchData = useCallback(async () => {
    setShowLoadingModal(true);
    try {
      const response = await axios_instance({
        url: "/dts/fetchDeferralList",
        method: "POST",
        data: { lead_id },
      });

      if (response.status === 200) {
        setDefferalList(response.data.deferral_data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoadingModal(false);
    }
  }, [lead_id, setShowLoadingModal]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="deferrallist-modal-content" ref={ref}>
        <div className="modal-header">
          <button
            type="button"
            className="close"
            onClick={closeDeferralListModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h5 className="modal-title" id="exampleModalLabel">
            Deferral List
          </h5>
        </div>
        <table className="table table-hover deferrallist-table">
          <thead>
            <tr>
              {deferralListColumns.map((col, idx) => {
                return (
                  <th key={idx} scope="col">
                    {col}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody id="deferral_list_table">
            {defferalList.map((val, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{val.ref_id}</td>
                <td>{val.reason}</td>
                <td>{val.remark}</td>
                <td>{val.due_date}</td>
                <td>{val.deferral_status}</td>
                <td>{val.created}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeDeferralListModal}
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default DeferralListModal;
